<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <card
          color="green"
          title="Dateien für Vereinsmitglieder"
        >
          <dropzone
            ref="dropzone"
            filetype="*"
            :files="urls"
            @removeFile="removeFile"
            :loading="loading"
            :filenames="true"
          />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="!changes" @click="save">Neue Dateien hochladen</v-btn>
          </v-card-actions>
        </card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable no-param-reassign */

import { Storage } from 'aws-amplify';
import Dropzone from '@/modules/files/_components/Dropzone';
import Card from '@/components/material/Card';

export default {
  name: 'list',
  components: {
    Card,
    Dropzone,
  },
  data() {
    return {
      changes: true,
      files: [],
      urls: [],
      loading: false,
    };
  },
  methods: {
    async save() {
      this.loading = true;
      const promises = [];
      const files = this.$refs.dropzone.getFileList();
      for (let i = 0; i < files.length; i += 1) {
        promises.push(Storage.put(`files/${files[i].name}`, files[i], {
          level: 'public',
          contentType: files[i].type,
        }));
      }
      await Promise.all(promises);
      this.loading = false;
      this.$refs.dropzone.clear();
      this.init();
    },
    init() {
      this.loading = true;
      Storage.list('files', { level: 'public' }).then((list) => {
        this.files = list;
        this.urls = [];
        list.forEach((image) => {
          Storage.get(image.key, { level: 'public' }).then((url) => {
            // const newFile = { name: url.split('/').pop().split('?')[0] };
            const ext = image.key.split('.').pop();
            if (['png', 'jpg', 'jpeg'].indexOf(ext.toLowerCase()) !== -1) {
              this.urls.push({ url, key: image.key.split('/').pop() });
            } else {
              this.urls.push({ url: '/img/file.png', key: image.key.split('/').pop() });
            }
          });
        });
        this.loading = false;
      });
    },
    removeFile(e) {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (confirm('Datei wirklich löschen?')) {
        this.urls.splice(e, 1);
        Storage.remove(this.files[e].key);
      }
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // this.destruct = true;
  },
};
</script>

<style scoped>

</style>
